import { render, staticRenderFns } from "./SettingsBotAgent.vue?vue&type=template&id=1e64b780&"
import script from "./SettingsBotAgent.vue?vue&type=script&lang=js&"
export * from "./SettingsBotAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports